export const hasStorage: boolean = ((): boolean => {
  try {
    localStorage.setItem('key', 'value')
    localStorage.removeItem('key')
    return true
  } catch (exception) {
    return false
  }
})()
